<template>
  <div class="pick-plan">
    <pick-plan-card
      v-for="(plan, index) in plans"
      :key="index"
      :plan="plan"
      @plan-picked="(plan) => $emit('plan-picked', plan)"
    />
  </div>
</template>

<script>
import PickPlanCard from "@/components/PickPlanCard.vue";
export default {
  components: { PickPlanCard },

  data() {
    return {
      plans: [
        {
          title: "Small",
          price: "995",
          currency: "DKK",
          frequency: "MO",
          description: "Up to 1.000 active products a year",
          features: ["1.000 active products", "Standard integrations", "Unlimited users", "Support included"],
          buttonText: "Start free trial"
        },
        {
          title: "Medium",
          price: "2495",
          currency: "DKK",
          frequency: "MO",
          description: "Up to 5.000 active products a year",
          features: [
            "5.000 active products",
            "Standard integrations",
            "Unlimited users",
            "Support included",
            "2 hours onboarding workshop"
          ],
          buttonText: "Start free trial"
        },
        {
          title: "Large",
          price: "3995",
          currency: "DKK",
          frequency: "MO",
          description: "Up to 10.000 active products a year",
          features: [
            "10.000 active products",
            "Standard integrations",
            "Unlimited users",
            "Support included",
            "2 hours onboarding workshop",
            "Dedicated Customer Success Manager"
          ],
          buttonText: "Start free trial"
        },
        {
          title: "Enterprise",
          price: "ASK",
          currency: "",
          frequency: "",
          description: "More than 10.000 active products a year",
          features: [
            "Unlimited active products",
            "Custom integrations",
            "Unlimited users",
            "Support included",
            "1 day onboarding workshop",
            "Dedicated Customer Success Manager"
          ],
          buttonText: "Start free trial"
        }
      ]
    };
  }
};
</script>

<style lang="less">
.pick-plan {
  display: flex;
  flex-direction: row;
  gap: 16px;
}
</style>
